import logger from "redux-logger";
import { configureStore } from "@reduxjs/toolkit";

import QuestionTableReducer from "@learningblocks/simulations/shared-components/lib/Questions/QuestionTableRedux/store/reducer";

export const Store = configureStore({
  reducer: {
    questionTable: QuestionTableReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
    }).concat(logger),
});
